export const experienceData = [
    {
        id: 1,
        company: 'Publicis Production (Publicis Global Delivery)',
        jobtitle: 'Frontend Developer',
        startYear: 'Jan 2026',
        endYear: 'Present',
        achievements: [
            'Develop and maintain digital experiences for an international brand account within Publicis Production, translating brand, content, and business requirements into reliable web solutions.',
            'Enhance complex Adobe Experience Manager solutions, including AEM Forms and Experience Fragments, to support efficient and adaptable content production.',
            'Use eDAM to organize and manage digital assets, helping teams deliver accurate and consistent content across web experiences.',
            'Develop and continuously improve responsive production websites with React and Styled Components, ensuring reliable functionality, visual consistency, and release quality.'
        ]
    },
    {
        id: 2,
        company: 'Publicis Global Delivery',
        jobtitle: 'Experience Technology Engineer (Frontend Developer)',
        startYear: 'Jul 2025',
        endYear: 'Dec 2025',
        achievements: [
            'Earned an accelerated promotion ahead of the company’s standard progression timeline by consistently exceeding leadership expectations and demonstrating strong technical growth.',
            'Expanded frontend responsibilities by delivering responsive AEM pages and reusable components while collaborating with Technology Managers and QA to maintain release quality.'
        ]
    },
    {
        id: 3,
        company: 'Publicis Global Delivery',
        jobtitle: 'Junior Experience Technology Engineer (Frontend Developer)',
        startYear: 'Nov 2023',
        endYear: 'Jun 2025',
        achievements: [
            'Collaborated with Technology Managers and QA engineers to validate releases, resolve issues, and ensure reliable product operation.',
            'Built and enhanced responsive web pages using Adobe Experience Manager components, aligning implementation with design and business requirements.',
            'Contributed to the development of an application that gave the client access to essential operational information and supported more informed decision-making.',
            'Developed a tablet application with React, JavaScript, and modern styling technologies that enabled users abroad to access relevant product information.',
            'Shared responsibility for the applications’ ongoing stability, presentation quality, and visibility across supported devices.'
        ]
    },
    {
        id: 4,
        company: 'Ambvalent',
        jobtitle: 'Frontend Developer',
        startYear: 'May 2023',
        endYear: 'Oct 2023',
        achievements: [
            'Designed and developed the product’s initial website, translating the brand vision into a creative, innovative, and responsive digital experience.',
            'Coordinated with the team to define communication flows and UX interactions, ensuring a clear and intuitive experience across the platform.',
            'Contributed to the leadership team responsible for strategic decisions throughout product creation, development, and launch.',
            'Built multiple web applications and websites conceived as Ambvalent digital products, expanding the company’s product portfolio.',
            'Collaborated across creative and technical disciplines to turn business ideas into functional, user-focused digital solutions.',
            'Strengthened brand visibility by supporting social media initiatives and presenting digital solutions to prospective clients.'
        ]
    },
    {
        id: 5,
        company: 'Aruna Asesores SAS',
        jobtitle: 'Corporate website development and maintenance',
        startYear: 'Oct 2021',
        endYear: 'Feb 2023',
        achievements: [
            'Delivered a digital brand refresh across the corporate website and social media channels, strengthening consistency and the company’s professional online presence.',
            'Coordinated cross-functional collaboration to design and launch a corporate website that addressed the company’s operational and communication requirements.',
            'Established the website as a direct communication channel for clients and stakeholders, improving access to company information and inquiries.',
            'Managed ongoing website maintenance, content updates, reliable operation, and security.'
        ]
    },
    {
        id: 6,
        company: 'Aruna Asesores SAS',
        jobtitle: 'Head of administrative division and quality',
        startYear: 'Jun 2020',
        endYear: 'Feb 2023',
        achievements: [
            'Brought accounts receivable and payable records up to date by reconciling debtor balances and supplier payments, reducing financial exposure and improving cash-flow visibility.',
            'Directed administrative operations for ArunaMex, the company’s Mexico branch, ensuring continuity, control, and the correct execution of day-to-day processes.',
            'Designed operational KPIs to measure internal performance, improve management visibility, and support data-driven decision-making.',
            'Managed operational relationships with international clients, coordinating requirements and maintaining reliable service continuity.',
            'Monitored regulatory filings and procedures with INVIMA, supporting timely completion and ongoing compliance.',
            'Standardized and documented administrative workflows, leaving an organized and sustainable operating structure.',
            'Led ISO 9001 implementation, strengthening process quality, regulatory alignment, and business continuity.'
        ]
    }
]